export enum ICategory {
  Component = 'component',
  LinesheetProduct = 'linesheet-product',
  Material = 'material',
  Product = 'product',
}

export type IAsset = IAssetCreateParams;

export interface IAssetCreateParams {
  type: ICategory;
  type_id: string;
  id: string;
  src: string;
  index: number;
}

export interface IDuplicateParams {
  assetIds: string[];
  typeId: string;
  type: ICategory;
}

export interface IFile extends Blob {
  name: string;
}

export interface IRemoveParams {
  ids: string[];
}

export interface IUploadOpts {
  record: IAssetCreateParams;
  validation: IValidation;
}

export interface IValidation {
  [validationKey: string]: (file: IFile) => boolean;
}
